import { render, staticRenderFns } from "./CreatModal.vue?vue&type=template&id=8d26794e&scoped=true"
import script from "./CreatModal.vue?vue&type=script&lang=ts"
export * from "./CreatModal.vue?vue&type=script&lang=ts"
import style0 from "./CreatModal.vue?vue&type=style&index=0&id=8d26794e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d26794e",
  null
  
)

export default component.exports